import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SessionService } from 'app/store/services/session.service';
import { CampaignService } from 'app/store/services/campaign.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { IReducers } from 'app/store/reducers';
import { openDialog } from 'app/store/actions/page.action';
import { InfoTipsComponent } from 'app/dialogs/info-tips/info-tips.component';
import { ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { MatStepper } from '@angular/material/stepper';
import { IUserSessionData, UserState } from 'app/store/models/user.model';
import { EReducers } from '../../store/reducers';
import { updateCampaign } from 'app/store/actions/campaigns.action';
import { DomSanitizer } from '@angular/platform-browser';
import { ICampaign } from '../../store/models/campaigns.model';

@Component({
  selector: 'app-preview-content',
  templateUrl: './preview-content.component.html',
  styleUrls: ['./preview-content.component.scss'],
})
export class PreviewContentComponent implements OnInit, OnDestroy {
  templates: any;
  dataReady = false;
  formGroup: FormGroup;
  state: string;
  campaignId: number;
  selectedIndex = 0;
  signature = '';
  userData: IUserSessionData;
  campaignInfo: ICampaign;
  @ViewChild('stepper') private MyStepper: MatStepper;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private sessionService: SessionService,
    private campaignService: CampaignService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<IReducers>,
    private readonly domSanitizer: DomSanitizer,
  ) {
    this.store.select(EReducers.USER).subscribe((userState: UserState) => {
      if (userState.sessionData) {
        this.userData = userState.sessionData;
        this.signature = this.userData.signature;
      }
    });
  }

  ngOnInit() {
    this.state = this.activatedRoute.snapshot.data.state;
    this.campaignId = this.activatedRoute.snapshot.params.id;

    this.sessionService
      .onReady()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.campaignService
          .getCampaignInfo(this.campaignId)
          .subscribe(response => {
            this.campaignInfo = response;
          });
        this.campaignService
          .getCampaignContents(this.campaignId)
          .subscribe(response => {
            this.templates = response;
            // sort the templates by the given `email_template(n)`
            this.templates.sort((a, b) => {
              const aTemplateNum = +a.content_template[a.content_template.length - 1];
              const bTemplateNum = +b.content_template[b.content_template.length - 1];

              if (aTemplateNum < bTemplateNum) {
                return -1;
              } else if (aTemplateNum > bTemplateNum) {
                return 1;
              }

              return 0;
            });
            this.formGroup = new FormGroup({});

            for (const item of this.templates) {
              this.formGroup.addControl(`form_${item.id}`, new FormGroup({}));
            }
            this.dataReady = true;
            if (this.activatedRoute.snapshot.queryParams.index) {
              this.selectedIndex =
                this.activatedRoute.snapshot.queryParams.index;
            }
          });
      });
  }

  getGroup(id: number) {
    return this.formGroup.get(`form_${id}`);
  }

  editTemplate(id: number, index: number) {
    this.router.navigate(
      [`/campaigns/${this.campaignId}/preview-content/${id}`],
      { queryParams: { index } },
    );
  }

  openFinishDialog() {
    this.store.dispatch(
      openDialog({
        dialogData: {
          title: 'Campaign Created Successfully',
          content: InfoTipsComponent,
          componentData: {
            type: 'complete_template_preview',
            campaignName: this.campaignInfo.campaign_name,
          },
          dialogMinWidth: '1000px',
          canClose: true,
          buttons: [
            {
              text: 'Ok',
              actAsClose: true,
              color: ButtonColor.GREEN,
              size: ButtonSize.NORMAL,
              onClick: () => this.activate(),
            },
          ],
        },
      }),
    );
  }

  stepperNext() {
    this.MyStepper.next();
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  activate() {
    const content = {
      campaign_id: this.campaignId,
      active_state: true,
    };
    this.store.dispatch(updateCampaign({ campaign: content }));
    this.router.navigate([`/campaigns`]);
  }

  getContent(content: string) {
    if (!content) {
      return '';
    }

    return this.domSanitizer.bypassSecurityTrustHtml(
      content.replace(/(\r\n)/gm, '<br>'),
    );
  }
}
